import Vue from 'vue'
import App from './App.vue'
import './assets/css/common.css'
import router from './router'
import store from './store'
import './registerServiceWorker'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLazyload from 'vue-lazyload'
import VueLodash from 'vue-lodash'
// axios.defaults.baseURL = 'http://web.93kk.com/';
Vue.use(VueAxios, axios)
Vue.use(VueLazyload)
Vue.use(VueLodash)
Vue.config.productionTip = false

 new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

